import MoodBadOutlinedIcon from '@mui/icons-material/MoodBadOutlined';
import MoodOutlinedIcon from '@mui/icons-material/MoodOutlined';
import SentimentNeutralOutlinedIcon from '@mui/icons-material/SentimentNeutralOutlined';
import React from 'react';

import { COLORS } from '../../../constants/colors';
import { DriverUpdatesStatus, LocationSharingStatus } from '../components/tabs/DriverAnalysisTab';

export const getStatusColor = (status: DriverUpdatesStatus | LocationSharingStatus) => {
    switch (status) {
        case DriverUpdatesStatus.ACCURATE:
        case LocationSharingStatus.ACCURATE:
            return COLORS.GREEN;
        case DriverUpdatesStatus.NO_UPDATES:
        case LocationSharingStatus.NO_UPDATES:
            return COLORS.ORANGE_OFFICIAL;
        case DriverUpdatesStatus.NOT_ACCURATE:
        case LocationSharingStatus.NOT_ACCURATE:
            return COLORS.RED;
        default:
            throw new Error('Driver update or location sharing status not supported');
    }
};

export const getStatusIcon = (status: DriverUpdatesStatus | LocationSharingStatus) => {
    switch (status) {
        case DriverUpdatesStatus.ACCURATE:
        case LocationSharingStatus.ACCURATE:
            return (
                <MoodOutlinedIcon
                    style={{
                        color: getStatusColor(status),
                        marginRight: '0.5rem',
                    }}
                />
            );
        case DriverUpdatesStatus.NO_UPDATES:
        case LocationSharingStatus.NO_UPDATES:
            return (
                <MoodBadOutlinedIcon
                    style={{
                        color: getStatusColor(status),
                        marginRight: '0.5rem',
                    }}
                />
            );
        case DriverUpdatesStatus.NOT_ACCURATE:
        case LocationSharingStatus.NOT_ACCURATE:
            return (
                <SentimentNeutralOutlinedIcon
                    style={{
                        color: getStatusColor(status),
                        marginRight: '0.5rem',
                    }}
                />
            );
        default:
            throw new Error('Driver update or location sharing status not supported');
    }
};
